import { render, staticRenderFns } from "./CommerceList.vue?vue&type=template&id=09bd30a7"
import script from "./CommerceList.vue?vue&type=script&lang=js"
export * from "./CommerceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports